// @flow
import Properties from "../../../Properties";
import { getInit, postInit, graphQLInit } from "../../global/types/constants";
import type { DispatchType } from "../../global/types/redux";
import {
  ProjectCompanyNode,
  ProjectNode,
  CompanyInfoNode,
  LicenceNode
} from "../../account/types/GraphQlNodes";
import { apiFailCallbackHandle } from "../../account/containers/ErrosDisplay";
import {
  ADMIN_UPDATE_PROJECT_LIST,
  ADMIN_SET_RESELLER_TREE,
  ADMIN_DELETE_PROJECT_LIST,
  ADMIN_PROJECT_ENDUSER_LIST,
  ADMIN_GET_PROJECT_LIST
} from "../../global/actions/actionNames";

const root = Properties.api_root;

export const fetchAdminResellerTree = (callback?: Function): * => (
  dispatch: DispatchType
): * => {
  const graphQl = `
  {
    allResellers {
      parent {
        ${CompanyInfoNode}
      }
      resellers {
        ${ProjectCompanyNode}
      }
    }
  }
  `;
  return fetch(`${root}/auth/v2/project/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: ADMIN_SET_RESELLER_TREE,
        resellers: json.data.allResellers
      });
      callback && callback(json.data.allResellers);
    });
};

export const fetcProjectList = (callback?: Function): * => (
  dispatch: DispatchType
): * => {
  const graphQl = `
  {
    allProjects {
      ${ProjectNode}
    }
  }
  `;
  return fetch(`${root}/auth/v2/project/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: ADMIN_GET_PROJECT_LIST,
        projects: json.data.allProjects
      });
      callback && callback(json.data.allProjects);
    });
};

export const deleteProject = (
  project_id: string,
  doneCallback: Function,
  failCallBack: Function
): * => (dispatch: any): * => {
  const graphQl = `
  mutation {
    deleteProject(
      projectId: "${project_id}"
    ){
      ok
      error {
        ... on ProjectNotFound{
          message
          errorType
        }
      }
    }
  }
  `;
  return fetch(`${root}/auth/v2/project/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      if (json.errors) {
        failCallBack && failCallBack(apiFailCallbackHandle(json.errors));
      } else {
        const result = json.data.deleteProject;
        if (result.ok) {
          dispatch({ type: ADMIN_DELETE_PROJECT_LIST, projectId: project_id });
          doneCallback && doneCallback();
        } else {
          failCallBack && failCallBack(apiFailCallbackHandle(result.error));
        }
      }
    })
    .catch(err => {
      failCallBack && failCallBack(apiFailCallbackHandle(err.message));
    });
};

export const fetchAdminEndUserLicenceList = (callback?: Function): * => (
  dispatch: DispatchType
): * => {
  const graphQl = `
  {
    allEndusers {
      ${CompanyInfoNode}
      licences {
        edges {
          node {
            ${LicenceNode}
            project{
              id
            }
          }
        }
      }
    }
  }
  `;
  return fetch(`${root}/auth/v2/project/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: ADMIN_PROJECT_ENDUSER_LIST,
        endusers: json.data.allEndusers
      });
      callback && callback(json.data.allEndusers);
    });
};
